<template>
  <div class="city-office-select">
    <el-select
      v-model="localBranchId"
      placeholder="Филиал"
      @change="onBranchChange"
      :disabled="disabled"
      popper-class="city-office-select-dropdown"
      style="width: 100%; max-width: 356px;"
    >
      <el-option-group
        v-for="city in cities"
        :key="'city-' + city.id"
        :label="city.name"
      >
        <el-option
          v-for="office in city.children || []"
          :key="'office-' + office.id"
          :label="office.name"
          :value="office.id"
        />
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CityOfficeSelect',
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localBranchId: this.modelValue
    }
  },
  computed: {
    ...mapState('cities', ['cities'])
  },
  watch: {
    modelValue(newVal) {
      if (newVal !== this.localBranchId) {
        this.localBranchId = newVal
      }
    },
    cities: {
      immediate: true,
      handler(citiesList) {
        if (this.localBranchId) return
        for (const city of citiesList || []) {
          if (Array.isArray(city.children) && city.children.length > 0) {
            this.localBranchId = city.children[0].id
            this.$emit('update:modelValue', this.localBranchId)
            break
          }
        }
      }
    }
  },
  methods: {
    onBranchChange(newId) {
      this.$emit('update:modelValue', newId)
    }
  }
}
</script>

<style scoped>
.city-office-select {
  width: 100%;
}

.city-office-select :deep(.el-select) {
  width: 100% !important;
  max-width: 356px !important;
}

.city-office-select :deep(.el-select__wrapper) {
  --el-border-color: rgba(0, 196, 255, 0.62) !important;
  --el-border-color-hover: rgba(0, 196, 255, 0.62) !important;
  --el-border-color-light: rgba(0, 196, 255, 0.62) !important;
  --el-color-primary: #00c4ff !important;
  --el-select-input-focus-border-color: rgba(0, 196, 255, 0.62) !important;
  box-sizing: border-box !important;
  width: 356px !important;
  min-height: 32px !important;
  height: 32px !important;
  padding: 0 13px 0 10px !important;
  background: #06122c !important;
  border: 0 !important;
  border-radius: 5px !important;
  box-shadow: inset 0 0 0 0.5px rgba(0, 196, 255, 0.62) !important;
  outline: 0 !important;
}

.city-office-select :deep(.el-select__wrapper:hover),
.city-office-select :deep(.el-select__wrapper.is-focused),
.city-office-select :deep(.el-select__wrapper.is-hovering),
.city-office-select :deep(.el-select.is-focused .el-select__wrapper) {
  background: #06122c !important;
  border-color: transparent !important;
  box-shadow: inset 0 0 0 0.5px rgba(0, 196, 255, 0.62) !important;
  outline: 0 !important;
}

.city-office-select :deep(.el-select__placeholder),
.city-office-select :deep(.el-select__selected-item) {
  color: #00c4ff !important;
  -webkit-text-fill-color: #00c4ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 17px !important;
  font-weight: 300 !important;
  line-height: 1 !important;
}

.city-office-select :deep(.el-select__wrapper),
.city-office-select :deep(.el-select__wrapper *) {
  font-family: var(--ui-font-family-base) !important;
  font-weight: 300 !important;
}

.city-office-select :deep(.el-select__caret) {
  position: relative !important;
  width: 7px !important;
  height: 6px !important;
  color: transparent !important;
  transform: none !important;
  transition: none !important;
}

.city-office-select :deep(.el-select__caret svg) {
  display: none !important;
}

.city-office-select :deep(.el-select__caret::before) {
  content: "" !important;
  display: block !important;
  width: 0 !important;
  height: 0 !important;
  border-left: 3.5px solid transparent !important;
  border-right: 3.5px solid transparent !important;
  border-top: 6px solid #00c4ff !important;
}
</style>

<style>
.city-office-select-dropdown,
.city-office-select-dropdown *,
.city-office-select-dropdown .el-select-group__title,
.city-office-select-dropdown .el-select-dropdown__item,
.city-office-select-dropdown .el-select-dropdown__item span {
  font-family: var(--ui-font-family-base) !important;
  font-weight: 300 !important;
}

.city-office-select-dropdown .el-select-group__title {
  color: #ffffff !important;
  opacity: 0.72;
}

.city-office-select-dropdown .el-select-dropdown__item {
  color: #d7e7ff !important;
}

.city-office-select-dropdown .el-select-dropdown__item.is-selected {
  color: var(--lineon-accent) !important;
}
</style>

